import React, { useState, useCallback, useEffect } from 'react'
import { View, Text, FlatList, TouchableOpacity, Image, Platform, useWindowDimensions } from 'react-native'
import { useFocusEffect, NavigationContext } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { useNavigation } from '../../hooks/useWebNavigation'
import { Subcategory } from './PortfolioSubcategory'
import { DotsNavigation } from '../navigation/stacks/NavigationStack'
import { CatalogueBrandsModel, CatalogueCategoriesModel } from './models/PortfolioModel'
import { openDB, getGlobalVersion, updateGlobalVersion } from '../../db/indexDB'
import {
    addCategory,
    getCategoriesWithSubcategoriesAndProducts,
    getCategoriesWithSubcategoriesAndProductsByBrandId,
    addBrand,
    getBrands,
} from '../../db/portfolio'
import NetInfo from '@react-native-community/netinfo'
import { apiUrl } from '../../config/config'
// import { fetchAuthSession } from 'aws-amplify/auth'
import { getAuthToken } from '../../utils/functions.utils'
import styles from './PortfolioStyles'
import { placeholderGeneral } from '../customUtils/Constants'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { useBreakpoint, useDimensionsStore } from '../../redux/zustand/useDimensionStore'

const Portfolio = () => {
    const [categorysArray, setCates] = useState<CatalogueCategoriesModel[]>([])
    const [brandsArray, setMarcas] = useState<CatalogueBrandsModel[]>([])

    const navigation = useNavigation()
    const [loaded, setLoaded] = useState(false)

    const goToSubCategory = (data: CatalogueCategoriesModel) => {
        console.log('[Portfolio][goToSubCategory] data:', data)
        console.log('[Portfolio][goToSubCategory] categories:', data.categories?.length, 'products:', data.products?.length)

        if (data.categories && data.categories.length > 0) {
            console.log('[Portfolio] Navegando a SubCategory con', data.categories.length, 'categorías')
            navigation.navigate('SubCategory', { id: data._id, categories: data.categories, isBrand: false })
        } else {
            console.log('[Portfolio] Navegando a PortfolioProducts con', data.products?.length || 0, 'productos')
            navigation.navigate('PortfolioProducts', { categoryId: data._id, products: data.products, item: data })
        }
    }
    const { languageFile } = getLanguage()
    const goToSubCategoryBrand = async (brand: CatalogueBrandsModel) => {
        const database = await openDB()
        getCategoriesWithSubcategoriesAndProductsByBrandId(database, brand._id)
            .then((categories) => {
                setCates(categories)

                const newCats = categories.map((category) => {
                    return { ...category, index_category: category.index_category }
                })
                navigation.navigate('SubCategory', { id: brand._id, categories: newCats, isBrand: false })
            })
            .catch((error) => {
                console.error('Error al obtener las categorías con subcategorías y productos:', error)
            })
    }

    const fetchData = async () => {
        try {
            let data
            const database = await openDB()
            const currentGlobalVersion = await getGlobalVersion(database, 'catalogue')
            console.log('🚀 currentGlobalVersion:', currentGlobalVersion)
            const netInfoState = await NetInfo.fetch()
            console.log('NetInfo.isConnected:', netInfoState.isConnected)
            let local_only = false
            let fetch_error = false

            const authToken = await getAuthToken()
            if (!authToken) {
                console.warn('[Portfolio] no authToken; using local catalogue only')
            }

            if (netInfoState.isConnected && !local_only && authToken) {
                const response = await fetch(`${apiUrl}/ecommerce_brands`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: authToken,
                        version: currentGlobalVersion,
                    },
                })
                console.log('verison que mando ,', currentGlobalVersion)
                if (!response.ok) {
                    console.error('Fallo al obtener el catalogo')
                    console.log('Intento consumir catalogo de mi local')

                    data = {
                        status: 0, // Asume un status 0 que es cuando tiene la misma version que la api // si paso status 2 tomo la data harcodeada
                    }

                    fetch_error = true
                }

                if (!fetch_error) {
                    data = await response.json()
                    console.log('🚀 ~ data.data_version:', data.single.data_version)
                }
            } else {
                // Usa datos locales si está fuera de línea
                console.log('sin conexion')
                data = {
                    status: 0, // Asume un status 0 que es cuando tiene la misma version que la api // si paso status 2 tomo la data harcodeada
                }
            }
            console.log('105 ---- 🚀 ~ ~ data.status:', data.status)

            if (data?.status === 1) {
                console.log('estoy en el status 1')
                let cate = data.single?.categories ?? []
                const updatedCategories = cate.map((category) => {
                    return { ...category, index_category: category.index }
                })
                console.log('INDEX 0', data.single?.categories[0].index, updatedCategories[0].index_category)
                let brand = data.single?.brands ?? []
                const updatedBrand = brand.map((bran, index) => {
                    return { ...bran, index_brand: bran.index ?? index }
                })

                setCates(updatedCategories)
                setMarcas(updatedBrand)
                // console.log('TAKA', data.single)
                updatedCategories.forEach(async (category) => {
                    try {
                        await addCategory(database, category)
                    } catch (error) {
                        //  console.log("🚀 ~ data.single.data.forEach ~ error:", error)
                    }
                })

                updatedBrand.forEach(async (brand) => {
                    try {
                        await addBrand(database, brand)
                    } catch (error) {
                        //  console.log("🚀 ~ data.single.data.forEach ~ error:", error)
                    }
                })

                let version_update = data.single.data_version
                await updateGlobalVersion(database, 'catalogue', version_update)
                console.log('guarda todo en local')
                console.log('CATES', updatedCategories[0].index_category)
            } else {
                console.log('✅ estopy en el local accaa')

                getBrands(database).then((brands) => {
                    setMarcas(brands)
                    // console.log('🚀 ~ .then ~ brands:', brands)
                })

                getCategoriesWithSubcategoriesAndProducts(database)
                    .then((categories) => {
                        // console.log('CATE 2', categories[0].index_category)
                        // console.log("🚀 ~ .then ~ categories:", categories)
                        setCates(categories)
                        // console.log('🚀 ~ .then ~ categories:', categories[0].index_category)
                    })
                    .catch((error) => {
                        console.error('Error al obtener las categorías con subcategorías y productos:', error)
                    })
            }
        } catch (error) {
            console.error('Error obteniendo el catalogo:', error.message, error.stack)
        }
        setLoaded(true)
    }

    const navigationCtx = React.useContext(NavigationContext)
    const useOptionalFocusEffect = (cb: () => void) => {
        if (navigationCtx) {
            // eslint-disable-next-line react-hooks/rules-of-hooks
            useFocusEffect(useCallback(cb, []))
        } else {
            // eslint-disable-next-line react-hooks/rules-of-hooks
            useEffect(() => {
                cb()
            }, [])
        }
    }

    useOptionalFocusEffect(() => {
        fetchData()
    })
    const bp = useBreakpoint()
    const smallWindow = bp === 'sm'
    switch (brandsArray.length) {
        case 0: {
            {
                return loaded ? (
                    <View style={styles.containerNoProducts}>
                        <Image style={styles.image} source={require('../../../assets/noBrands.png')} />
                        <Text style={styles.title}>{languageFile.no_brands_to_show}</Text>
                        <Text style={styles.description}>{languageFile.try_again_later}</Text>
                    </View>
                ) : (
                    <View />
                )
            }
        }
        case 1: {
            return <Subcategory subcategorys={categorysArray} goToSubCategory={goToSubCategory} />
        }
        default: {
            return <BrandsList brands={brandsArray} goToSubCategoryBrand={goToSubCategoryBrand} smallWindow={smallWindow} />
        }
    }
}

export default Portfolio

const isWeb = Platform.OS === 'web'

export const BrandsList = ({
    brands,
    goToSubCategoryBrand,
    smallWindow,
}: {
    brands: CatalogueBrandsModel[]
    goToSubCategoryBrand: (data: CatalogueBrandsModel) => void
    smallWindow?: boolean
}) => {
    const { languageFile } = getLanguage()

    const { width } = useWindowDimensions()

    const numColumns = isWeb ? (width >= 1080 ? 4 : !smallWindow ? 3 : 2) : 2

    return (
        <View style={[styles.container]}>
            <View style={styles.spacer1}></View>
            <View style={[styles.portfolioHeader, { marginBottom: smallWindow ? 8 : 20 }]}>
                <Text style={[styles.titleSection, !smallWindow && { fontSize: 24 }]}>{languageFile.portfolio}</Text>
                <Text style={[styles.descriptionSection, !smallWindow && { fontSize: 20 }]}>{languageFile.select_one}</Text>
            </View>
            <FlatList
                data={brands.sort((a, b) => a.index_brand - b.index_brand)}
                keyExtractor={(item) => item._id}
                horizontal={false}
                showsVerticalScrollIndicator={false}
                numColumns={numColumns}
                key={`columns-${numColumns}`}
                renderItem={({ item: item }) => (
                    <BrandsItems item={item} goToSubCategoryBrand={goToSubCategoryBrand} smallWindow={smallWindow} columns={numColumns} />
                )}
                contentContainerStyle={{ paddingHorizontal: smallWindow ? 10 : 16 }}
                columnWrapperStyle={{
                    gap: 20, // Espacio horizontal entre columnas
                }}
            />
        </View>
    )
}

export const BrandsItems = ({
    item,
    goToSubCategoryBrand,
    smallWindow,
    columns,
}: {
    item: CatalogueBrandsModel
    goToSubCategoryBrand: (data: CatalogueBrandsModel) => void
    smallWindow: boolean
    columns: number
}) => {
    return (
        <TouchableOpacity
            style={[styles.brandContainer, { maxWidth: '50%' }, !smallWindow && { maxWidth: '22%' }]}
            onPress={() => goToSubCategoryBrand(item)}
        >
            <Image source={{ uri: item.image ? item.image : placeholderGeneral }} style={styles.brandImage} resizeMode='cover' />
        </TouchableOpacity>
    )
}
